<template>
  <div>
    <router-view :maximized="maximized"></router-view>
  </div>
</template>
<script>
export default {
  name: "grpCenter"
};
</script>